const debounce = <T extends unknown[]>(
  func: (...args: T) => any,
  time = 1000
) => {
  let timeout: NodeJS.Timeout;
  return (...args: T) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), time);
  };
};

export default debounce;
